import { useLanguage } from "@/lib/language";

export default function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="inline-flex items-center gap-0.5 h-9 rounded-full bg-white border border-black/[0.08] p-0.5 shadow-[0_1px_2px_rgba(0,0,0,0.04)]" aria-label="Language">
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={`h-8 px-2 rounded-full text-[11px] transition-colors ${language === "en" ? "bg-[#F2E7DE] text-[#7B5844] font-semibold" : "text-[#8E8E93] hover:text-[#554941]"}`}
        aria-label="English"
        title="English"
      >
        🇬🇧
      </button>
      <button
        type="button"
        onClick={() => setLanguage("id")}
        className={`h-8 px-2 rounded-full text-[11px] transition-colors ${language === "id" ? "bg-[#F2E7DE] text-[#7B5844] font-semibold" : "text-[#8E8E93] hover:text-[#554941]"}`}
        aria-label="Indonesian"
        title="Indonesian"
      >
        🇮🇩
      </button>
    </div>
  );
}